(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaModule')
        .directive('commonActionPlanCriteria', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                actionPlanCriteria: '=',
                layoutRatio: '=?',
            },
            templateUrl: require('./actionPlanCriteria.tpl.html'),
            controller: ['$scope', '$state', 'historyCtxtService', function ($scope, $state, historyCtxtService) {

                // Go To ActionPlanCriteria
                $scope.goToActionPlanCriteria = function (actionPlanCriteria) {
                    historyCtxtService.goToState('actionPlanCriteriaEdit',
                      { ActionPlanCriteriaID: actionPlanCriteria.ActionPlanCriteriaID },
                      $state.current.name
                    );
                }

            }],
            link: function (scope, elem, attrs) {
                scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                    column: 'col-sm-12'
                };
            }
        }
    }
})();